<template>
  <section class="section" id="institution-detail">
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <h1 class="title">
      <a @click="$router.go(-1)">
        <b-icon icon="arrow-left" />
      </a>
      {{ institutionData.companyReference }} - {{ institutionData.companyName }}
    </h1>
    <br />
    <div class="columns">
      <div class="column">
        <collapse-field-detail
          :label="$t('Referencia organización')"
          :values="[institutionData.companyReference]"
        />
      </div>
      <div class="column">
        <collapse-field-detail
          :label="$t('Nombre organización')"
          :values="[institutionData.companyName]"
        />
      </div>
      <div class="column">
        <collapse-field-detail
          :label="$t('Dirección Website organización')"
          :values="[institutionData.companyWebsite]"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <collapse-field-detail
          :label="$t('Tipo de organización')"
          :values="[institutionData.companyType]"
        />
      </div>
      <div class="column">
        <collapse-field-detail
          :label="$t('Jurisdicción operativa positiva')"
          :values="institutionData.countries"
        />
      </div>
      <div class="column">
        <collapse-field-detail
          :label="$t('Sector actividad operativa')"
          :values="institutionData.businessSectors"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <collapse-field-detail
          :label="$t('Fase oportunidad recaudación/fundraising')"
          :values="institutionData.fundraisingOportunityPhases"
        />
      </div>
      <div class="column">
        <collapse-field-detail
          :label="$t('Tipo de organización aceptadas')"
          :values="institutionData.requesterCompanyTypes"
        />
      </div>
      <div class="column">
        <collapse-field-detail
          :label="
            $t('Tipos de programas de capital en Recaudación/Fundraising')
          "
          :values="institutionData.fundraisingProgramTypes"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <collapse-field-detail
          :label="$t('Criterios de importes de programas de Capital')"
          :values="institutionData.requestedAmountRanges"
        />
      </div>
      <div class="column">
        <collapse-field-detail
          :label="$t('Criterios de Cifra de EBITDA para organización')"
          :values="[institutionData.ebidtaAmountRanges]"
        />
      </div>
      <div class="column">
        <collapse-field-detail
          :label="$t('Criterios de importes de Ventas/Facturación')"
          :values="institutionData.sellsAmountRanges"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <collapse-field-detail
          :label="$t('Criterios de Divisas o Moneda Programa')"
          :values="institutionData.programCurrencyTypes"
        />
      </div>
      <div class="column">
        <collapse-field-detail
          :label="$t('Criterios auditor de cuentas')"
          :values="institutionData.hasAccountAuditor"
        />
      </div>
      <div class="column">
        <collapse-field-detail
          :label="$t('Direcciones de contacto')"
          :values="[
            institutionData.contactAddress.locality +
              ' / ' +
              institutionData.contactAddress.country
          ]"
        />
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <collapse-field-detail
          :label="$t('Persona de contacto')"
          :values="[institutionData.contactPerson]"
        />
      </div>
      <div class="column">
        <collapse-field-detail
          :label="$t('Casos de éxito')"
          :values="[institutionData.successStories]"
        />
      </div>
      <div class="column">
        <collapse-field-detail
          :label="$t('Noticias de interes')"
          :values="[institutionData.interestingNews]"
        />
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field :label="'- ' + $t('Otros')">
          <p>{{ institutionData.other }}</p>
        </b-field>
      </div>
      <div class="column">
        <collapse-field-detail
          :label="$t('Archivos')"
          :values="institutionData.files"
        />
      </div>
      <div class="column"></div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import CollapseFieldDetail from '@/components/common/CollapseFieldDetail'

export default {
  components: { CollapseFieldDetail },
  mixins: [],
  data: () => ({
    isLoading: false,
    institutionData: {}
  }),
  created() {},
  computed: {},
  mounted() {
    let self = this
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', this.$t(this.$route.meta.title)],
      title: this.$t(this.$t(this.$route.meta.title))
    })

    if (self.$route.name == 'admin.institutions.detail') {
      self.isLoading = true
      self
        .getInstitutionDetails(this.$route.params.id)
        .then(function(response) {
          self.institutionData = response.data
          self.isLoading = false
          console.log(response.data)
        })
        .catch(function(error) {
          self.isLoading = false
        })
    }
  },
  methods: {
    ...mapActions('institutions', [
      'postNewInstitution',
      'getInstitutionDetails'
    ])
  }
}
</script>

<style scoped>
#institution-detail .column {
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: #df4e88;
}
</style>
